import { toast } from 'react-toastify'
import Lib from 'utils/Lib.js'

export default {
  ValidateForm(form){
    if(!form.name){
      toast.warning("Name is empty!")
      return false
      
    } else if(!form.duration || !Lib.toInt(form.duration)) {
      toast.warning("Duration is empty or must greater than 0")
      return false

    } else if(!form.description) {
      toast.warning("Description is empty!")
      return false
    } 
    
    return true
  }
}



// WEBPACK FOOTER //
// ./src/App/master/maintenance_type/helper/form.js